import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const AddProduct = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    stock: "",
    category: "",
    avg: "",
    count: "",
    image: [],
  });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          "https://ecom-api.applligentdemo.com/category/getCategory",
          {
            headers: { Authorization: localStorage.getItem("token") },
          }
        );
        setCategories(res.data.categories || []);
      } catch (err) {
        console.error("Error fetching categories", err);
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData((prev) => ({ ...prev, image: files }));
    setPreviews(files.map((file) => URL.createObjectURL(file)));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const submitData = new FormData();
    submitData.append("name", formData.name);
    submitData.append("price", formData.price);
    submitData.append("description", formData.description);
    submitData.append("category", formData.category);
    submitData.append("stock", formData.stock);
    submitData.append("avg", formData.avg);
    submitData.append("count", formData.count);

    formData.image.forEach((img) => {
      submitData.append("image", img); // Adjust to "image[]" if backend requires
    });

    try {
      const res = await axios.post(
        "https://ecom-api.applligentdemo.com/product/createProduct",
        submitData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        toast.success(" Product created successfully!");
        navigate("/product");
      } else {
        toast.error(" Failed to save product.");
      }
    } catch (err) {
      console.error(
        " Product creation error:",
        err.response?.data || err.message
      );
      toast.error(` ${err.response?.data?.message || "Bad request"}`);
    }
  };
  const categoryClicked = () => {};
  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Button variant="secondary" onClick={() => navigate(-1)}>
        ← Back
      </Button>
      <Typography variant="h5" gutterBottom>
        Add New Product
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Product Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          margin="normal"
          multiline
          rows={3}
        />
        <TextField
          fullWidth
          label="Price"
          name="price"
          value={formData.price}
          onChange={handleChange}
          margin="normal"
          type="number"
          required
        />
        <TextField
          fullWidth
          label="Stock"
          name="stock"
          value={formData.stock}
          onChange={handleChange}
          margin="normal"
          type="number"
        />
        <TextField
          fullWidth
          label="Average Rating"
          name="avg"
          value={formData.avg}
          onChange={handleChange}
          margin="normal"
          type="number"
        />
        <TextField
          fullWidth
          label="Rating Count"
          name="count"
          value={formData.count}
          onChange={handleChange}
          margin="normal"
          type="number"
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>Category</InputLabel>
          <Select
            value={formData.category}
            name="category"
            label="Category"
            onChange={(e) => {
              const selectedId = e.target.value;
              setFormData((prev) => ({
                ...prev,
                category: selectedId,
              }));
              categoryClicked(selectedId); // call your function here
            }}
            required
          >
            {categories.map((cat) => (
              <MenuItem key={cat.id} value={cat._id}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <Button variant="outlined" component="label">
            Upload Images
            <input
              hidden
              type="file"
              multiple
              accept="image/*"
              onChange={handleImageChange}
            />
          </Button>
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: 10,
              flexWrap: "wrap",
            }}
          >
            {previews.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`preview-${index}`}
                style={{
                  width: 60,
                  height: 60,
                  objectFit: "cover",
                  borderRadius: 4,
                }}
              />
            ))}
          </div>
        </FormControl>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 3, mb: 5 }}
        >
          Save Product
        </Button>
      </form>
    </Container>
  );
};

export default AddProduct;